import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckVersions } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { TCMVersionsDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { IModalSelectOption } from '@components/common/ModalSelect/ModalSelect.types';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_VERSIONS } from '@constants/queryKeys';

interface IUseConsistencyCheckVersionsReturnType {
	versionOptions: IModalSelectOption[];
	isLoadingVersionOptions: boolean;
}

type TUseConsistencyCheckVersions = Partial<TCMVersionsDTO> & ICMMavenirVendor;

const useQueryConsistencyCheckVersions = (
	params: TUseConsistencyCheckVersions,
): IUseConsistencyCheckVersionsReturnType => {
	const {
		vendor,
		nodes,
		isMavenirVendor,
	} = params;

	const {
		data: versionOptions,
		isLoading: isLoadingVersionOptions,
		isFetching: isFetchingVersionOptions,
	} = useQuery<string[], IModalSelectOption[]>({
		queryKey: [
			CONSISTENCY_VERSIONS,
			params,
		],
		queryFn: extractQueryParams(getConsistencyCheckVersions),
		select: (options: string[]) => fieldsOptionsFormatted(options),
		enabled: [vendor, nodes?.length, isMavenirVendor],
		...refetchOptions,
	});

	return {
		versionOptions: versionOptions || [],
		isLoadingVersionOptions: (isLoadingVersionOptions && !!versionOptions)
			|| isFetchingVersionOptions,
	};
};

export default useQueryConsistencyCheckVersions;
